import { basicInitialState } from 'store/_utils/basicInitialState';
import { TCrmVesselsState } from './CrmVesselsModel';

export const CrmVesselsInitialState: TCrmVesselsState = {
  ...basicInitialState,
  crmVessels: null
};
